import { useMutation } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Hex } from 'ox'
import { useMemo } from 'react'
import { parseSiweMessage } from 'viem/siwe'

import * as SignFrames from '../-frames/sign/index.js'
import * as RemoteRpc from '../-lib/RemoteRpc.js'

export const Route = createFileRoute('/remote/rpc/personal_sign')({
  component: Component,
  validateSearch: (search) => RemoteRpc.validateSearch(search, { method: 'personal_sign' }),
})

function Component() {
  const request = Route.useSearch()
  const rpc = RemoteRpc.use()
  const consumer = RemoteRpc.useConsumer()
  const host = consumer.name ?? consumer.host

  const decoded = request._decoded?.params
  const [data] = decoded ?? []

  const { message, raw } = useMemo(() => {
    if (!data) return { message: undefined, raw: false }
    try {
      const text = Hex.toString(data)
      // eslint-disable-next-line no-control-regex
      const isPrintable = !/[\u0000-\u0008\u000e-\u001f]/.test(text)
      if (isPrintable) return { message: text, raw: false }
      return { message: data, raw: true }
    } catch {
      return { message: data, raw: true }
    }
  }, [data])

  const siwe = useMemo(() => {
    if (!message || raw) return null
    try {
      const parsed = parseSiweMessage(message)
      if (Object.keys(parsed).length > 0) return parsed
      return null
    } catch {
      return null
    }
  }, [message, raw])

  const confirm = useMutation({
    mutationFn: () => RemoteRpc.execute(rpc, { request }),
  })

  if (siwe)
    return (
      <SignFrames.Siwe
        confirming={confirm.isPending}
        host={host}
        onApprove={() => confirm.mutate()}
        onReject={() => rpc.reject()}
      />
    )

  return (
    <SignFrames.PersonalSign
      confirming={confirm.isPending}
      host={host}
      message={message}
      onConfirm={() => confirm.mutate()}
      onReject={() => rpc.reject()}
      raw={raw}
    />
  )
}
